import AddInfo from './add-info';
import WaitInfo from './wait-info';

export default {
  AddInfo,
  WaitInfo
};
